import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d9c591a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-red"
}
const _hoisted_2 = ["value", "disabled", "id"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form__radio-button" }, null, -1))
const _hoisted_5 = { class: "form__radio-label-text" }

import { ref, computed } from "vue";
import { requiredRule } from "@/utils/rules";

interface Option {
  label: string;
  value: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomRadioGroup',
  props: {
  options: {
    type: Array<Option>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: "",
  },
  rules: {
    type: Array,
    default: () => [],
  },
  required: {
    type: Boolean,
    default: true,
  },
  modelValue: null as any,
  isInsurance: {
    type: Boolean,
    default: false,
  },
  label2: {
    type: String,
    default: null,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





const selectedOption = ref("");
const sharedId = "option_" + Math.floor(Math.random() * 1000000);

const value = computed({
  get() {
    return selectedOption.value || props.modelValue;
  },
  set(newValue) {
    selectedOption.value = newValue;
    emit("update:modelValue", newValue);
  },
});

const rules: any = computed(() =>
  props.required ? [...(props.rules || []), requiredRule] : props.rules
);

return (_ctx: any,_cache: any) => {
  const _component_v_radio_group = _resolveComponent("v-radio-group")!

  return (_openBlock(), _createBlock(_component_v_radio_group, {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
    rules: rules.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(__props.isInsurance ? 'form__radio-group-insurance' : 'form__radio-group')
      }, [
        _createElementVNode("label", {
          class: _normalizeClass(__props.isInsurance ? 'form__label-insurance' : 'form__label')
        }, [
          _createTextVNode(_toDisplayString(__props.label2 || __props.label) + " ", 1),
          (__props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*"))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(
          __props.isInsurance
            ? 'form__input-container-insurance'
            : 'form__input-container'
        )
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                value: option.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
                disabled: __props.disabled,
                class: "form__radio-input",
                id: index + sharedId
              }, null, 8, _hoisted_2), [
                [_vModelRadio, value.value]
              ]),
              _createElementVNode("label", {
                for: index + sharedId,
                class: "form__radio-label"
              }, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, _toDisplayString(option.label), 1)
              ], 8, _hoisted_3)
            ]))
          }), 128))
        ], 2)
      ], 2)
    ]),
    _: 1
  }, 8, ["modelValue", "rules"]))
}
}

})